import {useCallback, useEffect, useState} from "react";
import {publicUrlFor} from "../../globals/constants";
import {trackPhoneClick} from "../../lib/gtag";

// Az elsodleges telefonszam - ugyanaz, mint a fejlecben elsokent kiirt szam.
const PRIMARY_PHONE = "06706251650";

/**
 * Lebego gyorshivo gomb a kepernyo jobb also sarkaban. A korabbi "ugras az
 * oldal tetejere" nyilat valtja ki: az oldal tetejen meg nem latszik (ott
 * ugyis ott vannak a hero hivogombjai), gorgetes utan viszont megjelenik.
 */
export default function QuickCallButton() {

  const [isVisible, setIsVisible] = useState(false);

  // A suti-sav a kepernyo aljara tapad, ezert amig kint van, feljebb toljuk
  // a gombot - kulonben eltakarna a legfontosabb CTA-t.
  const [bannerOffset, setBannerOffset] = useState(0);

  const measureBanner = useCallback(() => {
    const banner = document.querySelector(".alert.fixed-bottom");
    setBannerOffset(banner ? banner.getBoundingClientRect().height + 10 : 0);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
      measureBanner();
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, {passive: true});
    window.addEventListener("resize", measureBanner);
    // Kattintasra is merunk, hogy a suti-sav eltuntetese utan azonnal
    // visszacsusszon a gomb a helyere. A kis keses azert kell, mert a sav
    // csak a React ujrarajzolasa utan tunik el a DOM-bol.
    const measureAfterClick = () => setTimeout(measureBanner, 50);
    document.addEventListener("click", measureAfterClick);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", measureBanner);
      document.removeEventListener("click", measureAfterClick);
    };
  }, [measureBanner]);

  return (
    <a
      href={`tel:${PRIMARY_PHONE}`}
      onClick={() => trackPhoneClick('AW-17491861595/GmBFCJ-yi5AbENvA4pRB', PRIMARY_PHONE)}
      className={`quick-call-btn${isVisible ? "" : " is-hidden"}`}
      style={{bottom: `${15 + bannerOffset}px`}}
      aria-label="Hívjon minket most"
      title="Hívjon minket most!"
    >
      <img src={publicUrlFor("/assets/images/call.png")} alt=""/>
    </a>
  )
}
